module.exports = __webpack_public_path__ + "img/2.116bfa7d.jpg";